module.exports = __webpack_public_path__ + "static/media/activity-question-bg.c0138b62.png";